// extracted by mini-css-extract-plugin
module.exports = {"small":"JameoLogo_small__1uIKU","medium":"JameoLogo_medium__qNttO","large":"JameoLogo_large__jQmLc","logo":"JameoLogo_logo__hVPYH"};